var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "url(#5ccabp51ua)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ppw4kv36db",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 97
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    rx: 48.5,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ppw4kv36db)",
    fill: "#FDFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M62.227 92.604c0-1.16.468-2.272 1.301-3.092a4.48 4.48 0 0 1 3.142-1.281h8.887a4.48 4.48 0 0 0 3.142-1.281A4.34 4.34 0 0 0 80 83.857a4.34 4.34 0 0 0-1.301-3.093 4.48 4.48 0 0 0-3.142-1.28h-26.66a4.479 4.479 0 0 1-3.142-1.282 4.339 4.339 0 0 1-1.301-3.092 4.34 4.34 0 0 1 1.301-3.093 4.48 4.48 0 0 1 3.142-1.28h8.886a4.48 4.48 0 0 0 3.142-1.282 4.34 4.34 0 0 0 1.302-3.092c0-1.16-.468-2.273-1.302-3.093a4.48 4.48 0 0 0-3.142-1.281h-26.66a4.48 4.48 0 0 1-3.141-1.281 4.34 4.34 0 0 1-1.302-3.093 4.34 4.34 0 0 1 1.302-3.092 4.48 4.48 0 0 1 3.142-1.281h8.886a4.48 4.48 0 0 0 3.142-1.281 4.339 4.339 0 0 0 1.302-3.093c0-1.16-.468-2.272-1.302-3.093a4.48 4.48 0 0 0-3.142-1.28H13.35a4.48 4.48 0 0 1-3.141-1.281 4.34 4.34 0 0 1-1.302-3.093 4.34 4.34 0 0 1 1.302-3.093 4.48 4.48 0 0 1 3.142-1.28h8.886a4.48 4.48 0 0 0 3.142-1.282 4.34 4.34 0 0 0 1.301-3.092 4.34 4.34 0 0 0-1.301-3.093A4.48 4.48 0 0 0 22.237 27H5.353a47.459 47.459 0 0 0-5.05 27.237c1.064 9.37 4.903 18.226 11.037 25.466 6.135 7.241 14.296 12.548 23.47 15.261a49.622 49.622 0 0 0 28.128.002 4.324 4.324 0 0 1-.711-2.362z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.719 19.613c-2.043-3.125-4.651-5.54-7.363-8.052-.329-.305-.659-.61-.99-.92L36.382 10.3a4.74 4.74 0 0 0 0 9.48l52.337.143v-.309zm4.54 28.605a4.74 4.74 0 1 0 0 9.48l4.121-.033c.575-3.127.626-6.267.62-9.447h-4.74zM91.306 28.37a4.834 4.834 0 0 0 1.764-2.334 56.787 56.787 0 0 1 4.076 12.703H64.82a4.74 4.74 0 1 1 0-9.48h23.7a4.834 4.834 0 0 0 2.786-.889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.25 29h-22.5A3.75 3.75 0 0 0 34 32.75v32.5c0 2.11 1.64 3.75 3.75 3.75h22.5A3.75 3.75 0 0 0 64 65.25v-32.5c0-2.031-1.719-3.75-3.75-3.75zm0 36.25h-22.5v-32.5h22.5v32.5zm-15-27.5h7.5c.625 0 1.25-.547 1.25-1.25 0-.625-.625-1.25-1.25-1.25h-7.5c-.703 0-1.25.625-1.25 1.25 0 .703.547 1.25 1.25 1.25zM49 51.5c2.734 0 5-2.188 5-5 0-2.734-2.266-5-5-5-2.813 0-5 2.266-5 5 0 2.813 2.188 5 5 5zm-7.031 10h13.984c1.016 0 1.797-.625 1.797-1.484V58.53c0-2.5-2.422-4.531-5.313-4.531-.78 0-1.406.625-3.437.625-2.11 0-2.656-.625-3.516-.625-2.89 0-5.234 2.031-5.234 4.531v1.485c0 .859.781 1.484 1.719 1.484z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5ccabp51ua",
    x1: 97,
    y1: 0,
    x2: 0,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF861E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIllustration);
export default __webpack_public_path__ + "static/media/successIllustration.2c10b6709755d337d59236fb476c4e09.svg";
export { ForwardRef as ReactComponent };